// extracted by mini-css-extract-plugin
module.exports = {"modal":"ReissueStudentPasswordModal_modal__1iUBW"};